<div class="view-wrapper">
    <dx-scroll-view class="view-wrapper-scroll" (onScroll)="scroll($event)">
        <div class="dx-card responsive-paddings">
            <dx-toolbar [class]="isContentScrolled ? 'header-toolbar-scrolled' : 'header-toolbar'"
                [class.scrolled]="isContentScrolled">
                <dxi-item location="before">
                    <div class="header-text">Merchant Dashboard</div>
                </dxi-item>
            </dx-toolbar>


            <div class="cards-container">
                <div class="cards grey" *ngIf="this.cardDataValues.length > 0">
                    <div
                        *ngFor="let card of this.cardDataValues | orderBy:'titleText':['Active Merchants', 'Merchant Accounts Balance', 'Wallets Balance','Active Cards', 'Cards Balance']">
                        <app-data-information-card [icon]="card.icon" [titleText]="card.titleText"
                            [data]="card"></app-data-information-card>

                    </div>
                </div>
            </div>

            <div class="container">
                <div class="header-buttons" hidden>

                </div>
                <dx-data-grid id="merchantsGrid" [rowAlternationEnabled]="true" [dataSource]="merchantsDataSource"
                    [remoteOperations]="{
                        filtering: true,
                        grouping: true,
                        groupPaging: false,
                        paging: true,
                        sorting: true,
                        summary: false }"

                    height="'auto'"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [width]="'100%'"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [wordWrapEnabled]="true"
                    [showRowLines]="true"
                    (onCellPrepared)="onCellPrepared($event)" (onExporting)="onExporting($event)"
                    class="bordered-grid">
                    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                    <dxo-filter-row [visible]="true" [applyFilter]="{
                                key: 'auto',
                                name: 'Immediately',
                              }"></dxo-filter-row>

                    <dxo-paging [pageSize]="20"></dxo-paging>

                    <dxo-pager [visible]="true" [showPageSizeSelector]="true"
                        [allowedPageSizes]="[5,10,20, 25, 50, 100]">
                    </dxo-pager>

                    <dxo-export [enabled]="true" [formats]="['pdf', 'xlsx']">
                    </dxo-export>

                    <dxo-header-filter [visible]="true"></dxo-header-filter>

                    <dxi-column dataField="Merchant" caption="Merchant" dataType="string" alignment="left"
                        [allowHeaderFiltering]="true" [allowFiltering]="true">
                    </dxi-column>


                    <dxi-column dataField="Status" caption="Status" dataType="string" alignment="right" [width]="100"
                        [allowHeaderFiltering]="true" [allowFiltering]="true">
                    </dxi-column>

                    <dxi-column dataField="AccountBalance" caption="Account Balance" dataType="string"
                        [format]="customCurrencyFormat" alignment="right" [allowHeaderFiltering]="false"
                        [allowFiltering]="false">
                    </dxi-column>

                    <dxi-column dataField="WalletsCount" caption="Wallets" dataType="number" alignment="right"
                        [allowHeaderFiltering]="false" [allowFiltering]="false">
                    </dxi-column>

                    <dxi-column dataField="WalletsBalance" caption="Wallets Balance" dataType="number"
                        [format]="customCurrencyFormat" alignment="right" [allowHeaderFiltering]="false"
                        [allowFiltering]="false">
                    </dxi-column>

                    <dxi-column dataField="ActiveCards" caption="Active Cards" dataType="string" alignment="right"
                        [allowHeaderFiltering]="false" [allowFiltering]="false">
                    </dxi-column>

                    <dxi-column dataField="CardBalance" caption="Cards Balance" dataType="number"
                        [format]="customCurrencyFormat" alignment="right" [allowHeaderFiltering]="false"
                        [allowFiltering]="false">
                    </dxi-column>

                    <dxi-column dataField="CardStock" caption="Cards Stock" dataType="number" alignment="right"
                        [allowHeaderFiltering]="false" [allowFiltering]="false">
                    </dxi-column>


                    <dxo-summary>
                        <dxi-total-item column="Merchant" summaryType="count"> </dxi-total-item>
                    </dxo-summary>

                </dx-data-grid>
            </div>
        </div>
    </dx-scroll-view>

</div>
